import { _Omit } from '@noths/polaris-dev-ts-recipes';

import { PageProps, ProductFieldObject } from 'src/types';
import { generateProductFieldObject } from './googleAnalytics';

export type PageEcommerceObject = _Omit<ProductFieldObject, 'quantity'>;

export interface PageEventObject {
  page: {
    category: 'Product';
    environment: string;
    react: 'true';
    app_version: string;
    release_version: string;
  };
  ecommerce: {
    detail: { products: PageEcommerceObject[] };
  };
}

export const generatePageEventObject = (
  pageProps: PageProps,
  version: string,
  appVersion: string,
) => {
  if (!pageProps?.updatedReduxState) {
    return '';
  }

  const { product, personalisation, deliveryZoneOptions } = pageProps.updatedReduxState;

  const { quantity, ...productEcommerce }: ProductFieldObject = {
    ...generateProductFieldObject({
      product,
      personalisation,
      deliveryZoneOptions,
    }),
    dimension92: String(product.options.length),
  };

  const pageEventObject: PageEventObject = {
    page: {
      category: 'Product',
      environment: process.env.NODE_ENV,
      react: 'true',
      app_version: appVersion,
      release_version: version,
    },
    ecommerce: {
      detail: {
        products: [productEcommerce],
      },
    },
  };

  return JSON.stringify(pageEventObject);
};
